import axios from "axios";
import {getInfoSessionByID} from "../../services/ApiServices";

const state = {
    showList: [],
    headers: [],
    infoSessions: [],
    currentInfoSession: {},
    barStatus: {
        applicantsIsActive: true,
        nonApplicantIsActive: false,
        registeredIsActive: false,
    },
}

const getters = {
    getShowList: state => state.showList,
    getHeaders: state => state.headers,
    getInfoSessions: state => state.infoSessions,
    getBarStatus: state => state.barStatus,
    getCurrentInfoSession: state => state.currentInfoSession,
}

const actions = {
    fetchInfoSession({ state }, id) {
        const headers = JSON.parse(sessionStorage.getItem('headers'))
        axios.get(getInfoSessionByID(id), {headers: headers})
            .then(res => {
                // commit('setShowList', res.data)
                console.log(res.data)
                setCurrentInfoSession(state, res.data)
            }).catch(err => console.log(err))
    },
    setInfoSessions({ commit }, infoSessions) {
        commit('setInfoSessions', infoSessions)
    },
    setHeaders({ commit }, headers) {
        commit('setHeaders', headers)
    },
    setBarStatus({ commit }, target) {
      commit('setBarStatus', target)
    },
    setShowList({ commit }) {
        commit('setShowList')
    }
}

const mutations = {
    setShowList: (state) => {
        // setCurrentInfoSession(state)
        let list = state.currentInfoSession
        const currentView = Object.keys(state.barStatus).find(key => state.barStatus[key] === true)
        if (currentView === 'applicantsIsActive')
            list = list.applicantsInAttendance
        if (currentView === 'nonApplicantIsActive')
            list = list.nonApplicantsInAttendance
        if (currentView === 'registeredIsActive')
            list = list.registeredApplicants
        state.showList = list
    },
    setInfoSessions: (state, infoSessions) => state.infoSessions = infoSessions,
    setHeaders: (state, headers) => state.headers = headers,
    setBarStatus: (state, target) => {
        Object.keys(state.barStatus).map(status => state.barStatus[status] = false)
        state.barStatus[target] = true
    },
}

const setCurrentInfoSession = (state, infoSession) => state.currentInfoSession = infoSession

export default {
    state,
    getters,
    actions,
    mutations
}